var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoOutline = function SvgInfoOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5,13 C28.925,13 13,28.925 13,48.5 C13,68.075 28.925,84 48.5,84 C68.075,84 84,68.075 84,48.5 C84,28.925 68.075,13 48.5,13 M48.5,88 C26.72,88 9,70.28 9,48.5 C9,26.72 26.72,9 48.5,9 C70.28,9 88,26.72 88,48.5 C88,70.28 70.28,88 48.5,88 Z M48.5,40 C46.8431458,40 45.5,41.3431458 45.5,43 L45.5,67 C45.5,68.6568542 46.8431458,70 48.5,70 C50.1568542,70 51.5,68.6568542 51.5,67 L51.5,43 C51.5,41.3431458 50.1568542,40 48.5,40 Z M48.5,26 C46.290861,26 44.5,27.790861 44.5,30 C44.5,32.209139 46.290861,34 48.5,34 C50.709139,34 52.5,32.209139 52.5,30 C52.5,27.790861 50.709139,26 48.5,26 Z",
    fill: "#000000",
    fillRule: "evenodd"
  })));
};
export default SvgInfoOutline;